import classNames from "classnames";
import React from "react";

import Link from "@atoms/Link";

import { URLS } from "@const/urls";

export default function Preview() {
  return (
    <section className="relative h-screen w-screen overflow-hidden">
      <video autoPlay className="absolute inset-0 h-full w-full object-cover" draggable={false} loop muted playsInline>
        <source src="https://cdn.shopify.com/videos/c/o/v/cc9020adca0749c8b10b6221d839d93d.mp4" type="video/mp4" />
      </video>

      <header className="pc:grid pc:grid-cols-12 pc:px-5 pc:py-3.75 fixed top-0 z-10 flex w-full flex-col justify-between px-4 py-3.5 text-lg">
        <Link
          className={classNames("text-title font-features-normal pc:col-span-2 pc:pb-0 pb-4 leading-none")}
          href={URLS.HOME}
        >
          thisisneverthat®
        </Link>
        <div className="pc:col-span-10 pc:col-start-3 pc:pt-0 flex flex-col pt-4">
          <p>
            Our online store is currently under maintenance.
            <br className="pc:hidden" />
            The website will reopen on August 14, 2026.
          </p>
          <p>現在、オンラインストアはメンテナンス中です。 2026年8月14日に再開いたします。</p>
        </div>
      </header>

      {/* Notice */}
      <article className="pc:bottom-5 pc:left-5 pc:right-auto pc:w-full-grid-cols-4 fixed right-4 bottom-4 left-4 z-20 flex flex-col gap-5 bg-neutral-100/95 p-5 break-words shadow lg:w-1/4 dark:bg-black/98 dark:text-white dark:shadow-white">
        <div className="flex">
          <h3 className="break-all">【公式オンラインストアのリニューアルに伴う一時休止のお知らせ】</h3>
        </div>
        <div>
          休止期間：8月12日（火）18:00 ～ 8月14日（金）12:00
          <br />
          返品受付・お問い合わせ：
          <a href="mailto:cs_jp@thisisneverthat.com">cs_jp@thisisneverthat.com</a>
          <br />
          <br />
          ※既にご注文頂いている商品は、サイト休止期間中も順次発送いたします。
        </div>
      </article>
    </section>
  );
}
